var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-frappe-chart',_vm._b({},'v-frappe-chart',{..._vm.$props, ..._vm.$attrs},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }